var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.75H19C19.6908 4.75 20.25 5.30921 20.25 6V19C20.25 19.6908 19.6908 20.25 19 20.25H5C4.30921 20.25 3.75 19.6908 3.75 19V6C3.75 5.30921 4.30921 4.75 5 4.75Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2V6",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2V6",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H21",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0127 12.7285C11.8747 12.7285 11.7627 12.8405 11.7637 12.9785C11.7637 13.1165 11.8757 13.2285 12.0137 13.2285C12.1517 13.2285 12.2637 13.1165 12.2637 12.9785C12.2637 12.8405 12.1517 12.7285 12.0127 12.7285",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.499 12.7285C7.361 12.7285 7.249 12.8405 7.25 12.9785C7.25 13.1165 7.362 13.2285 7.5 13.2285C7.638 13.2285 7.75 13.1165 7.75 12.9785C7.75 12.8405 7.638 12.7285 7.499 12.7285",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0127 12.7285C16.8747 12.7285 16.7627 12.8405 16.7637 12.9785C16.7637 13.1165 16.8757 13.2285 17.0137 13.2285C17.1517 13.2285 17.2637 13.1165 17.2637 12.9785C17.2637 12.8405 17.1517 12.7285 17.0127 12.7285",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0127 16.25C16.8747 16.25 16.7627 16.362 16.7637 16.5C16.7637 16.638 16.8757 16.75 17.0137 16.75C17.1517 16.75 17.2637 16.638 17.2637 16.5C17.2637 16.362 17.1517 16.25 17.0127 16.25",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.499 16.25C7.361 16.25 7.249 16.362 7.25 16.5C7.25 16.638 7.362 16.75 7.5 16.75C7.638 16.75 7.75 16.638 7.75 16.5C7.75 16.362 7.638 16.25 7.499 16.25",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0127 16.25C11.8747 16.25 11.7627 16.362 11.7637 16.5C11.7637 16.638 11.8757 16.75 12.0137 16.75C12.1517 16.75 12.2637 16.638 12.2637 16.5C12.2637 16.362 12.1517 16.25 12.0127 16.25",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.96f4358734d79ff9d86a17465fbe371a.svg";
export { ForwardRef as ReactComponent };